import { render } from "./HotelDetailBanner.vue?vue&type=template&id=089d78c4"
import script from "./HotelDetailBanner.vue?vue&type=script&lang=js"
export * from "./HotelDetailBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__